module.exports = __webpack_public_path__ + "static/media/lapor_diri.89524ea9.svg";